module.exports = __webpack_public_path__ + "img/trofeu-ranking.0a797a7f.svg";